import { Link } from "react-router-dom";

/**
 * ImpactVest header brand mark — the original green-and-gold emblem rendered
 * cleanly on the neutral header background, without the full gold square tile.
 * A soft gold disc holds the two-leaf sprout, preserving the two-color identity.
 */
export default function BrandMark({ className = "", size = 44, to = "/", ...rest }) {
  return (
    <Link
      to={to}
      aria-label="ImpactVest home"
      className={`inline-flex items-center justify-center ${className}`}
      style={{ padding: 4 }}
      {...rest}
    >
      <svg
        viewBox="0 0 120 120"
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="block"
      >
        <defs>
          <linearGradient id="ivGold" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#d9c48c" />
            <stop offset="45%" stopColor="#c9a869" />
            <stop offset="100%" stopColor="#8f7538" />
          </linearGradient>
        </defs>

        {/* Gold disc — retains the identity's gold element without the full square tile */}
        <circle cx="60" cy="60" r="54" fill="url(#ivGold)" />
        <circle cx="60" cy="60" r="54" fill="none" stroke="#8f7538" strokeOpacity="0.55" strokeWidth="1" />
        {/* Inner warm-gold ring detail */}
        <circle cx="60" cy="60" r="46" fill="none" stroke="#8f7538" strokeOpacity="0.28" strokeWidth="0.8" />

        {/* Left leaf — deep institutional green */}
        <path
          d="M60 84 C 38 84, 28 66, 30 44 C 30 42, 32 40, 34 41 C 54 44, 60 60, 60 84 Z"
          fill="#0e5a3e"
        />
        {/* Right leaf */}
        <path
          d="M60 84 C 60 60, 70 42, 90 34 C 92 33, 94 34, 94 36 C 94 60, 84 82, 60 84 Z"
          fill="#0e5a3e"
        />
        {/* Warm-gold stem accent between the leaves */}
        <path
          d="M60 84 L 60 96"
          stroke="#8f7538"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        {/* Warm-gold vein highlight on the right leaf */}
        <path
          d="M60 84 C 68 72, 76 62, 88 52"
          stroke="#d9c48c"
          strokeOpacity="0.7"
          strokeWidth="1.2"
          strokeLinecap="round"
          fill="none"
        />
        {/* Subtle secondary vein on the left leaf */}
        <path
          d="M60 84 C 52 74, 44 64, 34 54"
          stroke="#d9c48c"
          strokeOpacity="0.4"
          strokeWidth="0.9"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    </Link>
  );
}
